import {Modal} from 'bootstrap';
import BaseComponent from '../../../../../common/js/BaseComponent';
import Helper from '../../../../../common/utils/helper';
import Quantity from './Quantity';
import Login from '../Auth/Login';

export default class Product extends BaseComponent {
    addToCartModalElement: HTMLElement | null;

    addToCartModalInstance: Modal | null;

    private modalElement: HTMLElement | null;

    private modalContent: HTMLElement | null;

    successModalElement: HTMLElement | null;

    successModalInstance: Modal | null;

    guestModalElement: HTMLElement | null;

    guestModalInstance: Modal | null;

    getSelectorChooseWishlist(): HTMLSelectElement | null {
        return this.successModalElement?.querySelector('#choose-success-selector') ?? null;
    }

    init(): void {
        this.modalElement = document.getElementById('addToBasket');
        this.modalContent = document.getElementById('addToBasketContent');
        this.initEvents();
    }

    static getSelectorReferenceBoxProduct(): string {
        return '.reference-box-product';
    }

    static getSelectorAddCart(): string {
        return '.product-infos .btn-add-cart';
    }

    getElementProductInfo() {
        return $('#product_infos_wrapper');
    }

    static getElementInputQuantity(): HTMLInputElement | null {
        return document.querySelector('input[name=\'product-count\']');
    }

    static getSelectorCtaContainer(): HTMLElement | null {
        return document.querySelector('.product-infos .product-form-cta');
    }

    static getProductId() {
        const cta = Product.getSelectorCtaContainer();
        return cta ? cta.getAttribute('data-product_id') : null;
    }

    static getCartQuantity(): number {
        const inputQty = Product.getElementInputQuantity();
        return inputQty ? parseInt(inputQty.value, 10) : 1;
    }

    updateCartViews(data: any) {
        (window as any).updateCartViews(data);
    }

    private displaySuccessModal() {
        return fetch('/mon-panier/getSuccessModal', {
            method: 'POST',
            headers: Helper.createFetchHeader(),
            body: JSON.stringify({}),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                this.createModal(data);
            });
    }

    private createModal(data: string) {
        // On inject ma modal dans mon DOM
        document.body.insertAdjacentHTML('beforeend', data);
        // On va récupérer la modal précédement injectée
        this.successModalElement = document.getElementById('validate');
        // On vérifie que la modal existe bien
        if (this.successModalElement) {
            // On affiche ma modale
            this.successModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.successModalElement);
            this.successModalInstance.show();
        }
    }

    addToCart(element) {
        const body = {
            product_id: Product.getProductId(),
            quantity: Product.getCartQuantity(),
            return_templates: ['cart-header'],
        };
        fetch(element.getAttribute('data-href'), {
            method: 'POST',
            body: JSON.stringify(body),
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.json()]))
            .then((data) => {
                this.updateCartViews(data[1]);
                if (this.view.getAttribute('data-modal') === 'true') {
                    this.addToCartModalElement = document.getElementById('addToBasket-2');
                    this.addToCartModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.addToCartModalElement);
                    this.addToCartModalElement?.remove();
                    this.addToCartModalInstance = null;
                }

                // si on est dans le mode commandé en tant que invité
                if (this.view.getAttribute('data-guess') === 'true') {
                    this.guestModalElement = document.getElementById('modalAccount');
                    this.guestModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.guestModalElement);
                    this.guestModalElement?.remove();
                    this.guestModalInstance = null;
                }
                this.displaySuccessModal();
            })
            .catch((error) => {
                console.log(error);
                Helper.createToastElement('Une erreur s\'est produite', 'error');
            });
    }

    getGuestModal(element) {
        const body = {
            product_id: Product.getProductId(),
            quantity: Product.getCartQuantity(),
            return_templates: ['cart-header'],
        };
        fetch(element.getAttribute('data-href'), {
            method: 'POST',
            body: JSON.stringify(body),
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                if (this.view.getAttribute('data-modal') === 'true') {
                    this.addToCartModalElement = document.getElementById('addToBasket-2');
                    this.addToCartModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.addToCartModalElement);
                    this.addToCartModalElement?.remove();
                    this.addToCartModalInstance = null;
                }
                this.createGuestModal(data);
            })
            .catch((error) => {
                // @TODO
                Helper.createToastElement('Une erreur s\'est produite', 'error');
            });
    }

    private createGuestModal(data: string) {
        // On inject ma modal dans mon DOM
        document.body.insertAdjacentHTML('beforeend', data);

        // On va récupérer la modal précédement injectée
        this.guestModalElement = document.getElementById('modalAccount');
        // On vérifie que la modal existe bien
        if (this.guestModalElement) {
            // On affiche ma modale
            this.guestModalInstance = window.bootstrap.Modal.getOrCreateInstance(this.guestModalElement);
            this.guestModalInstance.show();
            (() => new Product(this.guestModalElement.querySelector('[data-mount="Product"]')))();
        }
    }

    initEvents(): void {
        this.initProductDropDown();
        this.view.querySelectorAll('.btn-add-cart').forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const auth = item.getAttribute('data-auth');
                if (auth == 1) {
                    this.addToCart(item);
                } else {
                    this.getGuestModal(item);
                }
            });
        });
        this.view.querySelectorAll('.modal-login').forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const auth = item.getAttribute('data-auth');
                if (auth == 0) {
                    (() => new Login(this.view.querySelector('[data-mount="Login"]')))();
                }
            });
        });
        this.view.querySelectorAll('.btn-add-cart-guess').forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                this.addToCart(item);
            });
        });

        this.view.querySelectorAll('.reference-box-product').forEach((item) => {
            item.addEventListener('click', (e) => {
                fetch(item.getAttribute('data-href'), {
                    method: 'GET',
                    headers: Helper.createFetchHeader(),
                })
                    .then((response) => Promise.all([response, response.json()]))
                    .then(([, data]) => {
                        if (data) {
                            if (this.view.getAttribute('data-modal') === 'false') {
                                this.view.innerHTML = data.product_view;
                            } else {
                                this.view.innerHTML = data.modal_product_view;
                            }
                            (() => new Quantity(this.view.querySelector('[data-mount="Quantity"]')))();
                            this.initEvents();
                        }
                    });
            });
        });

        this.view.querySelectorAll('.color-choice').forEach((item) => {
            item.addEventListener('click', (e) => {
                const body = {
                    parent_id: item.getAttribute('data-parent-id'),
                    position: item.getAttribute('data-feature-position'),
                    feature_value_id: item.getAttribute('data-feature-value-id'),
                };
                fetch(item.getAttribute('data-href'), {
                    method: 'POST',
                    body: JSON.stringify(body),
                    headers: Helper.createFetchHeader(),
                })
                    .then((response) => Promise.all([response, response.json()]))
                    .then(([, data]) => {
                        if (data) {
                            if (this.view.getAttribute('data-modal') === 'false') {
                                this.view.innerHTML = data.product_view;
                            } else {
                                this.view.innerHTML = data.modal_product_view;
                            }
                            (() => new Quantity(this.view.querySelector('[data-mount="Quantity"]')))();
                            this.initEvents();
                        }
                    });
            });
        });
    }

    static displayInfoProduct(element) {
        fetch(element.getAttribute('data-href'), {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.json()]))
            .then(([, data]) => {
                if (data) {
                    if (this.view.getAttribute('data-modal') === 'false') {
                        this.view.innerHTML = data.product_view;
                    } else {
                        this.view.innerHTML = data.modal_product_view;
                    }
                    Product.init();
                }
            });
    }

    initProductDropDown() {
        const dropdown = this.view.querySelector('#myDropdown');
        if (dropdown) {
            dropdown.addEventListener('click', () => {
                dropdown.classList.toggle('active');
            });
        }
    }

    updateModalView(element: HTMLLinkElement): void {
        fetch(element.getAttribute('href') ?? '/', {
            method: 'GET',
            headers: Helper.createFetchHeader(),
        })
            .then((response) => Promise.all([response, response.text()]))
            .then(([, data]) => {
                const modalContent = document.querySelector('#addToBasketContent');
                if (modalContent) {
                    modalContent.innerHTML = data;
                }
            });
    }
}
